import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import routes from '../routes/route';
import viewRelatedUsers from './viewRelatedUsers';

export default {
  attributeName: 'devices',
  isDragable: false,
  canOpen: true,
  canEdit: true,
  canCreate: false,
  createPath: routes.DEVICES_NEW,
  editURL: routes.DEVICES_EDIT,
  canRemove: true,
  emptyMessage: "You don't have devices yet. Click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'id',
      label: 'ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Internal device identifier.',
      canEdit: false,
      canCreate: false,
      canFilter: false,
      width: '6rem',
      hidden: true,
    },
    {
      attributeName: 'inventoryId',
      label: 'Inventory ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Auto-generated inventory identifier based on device type.',
      canEdit: false,
      canCreate: false,
      canFilter: true,
      canOrder:true,
      width: '14rem',
    },
    {
      attributeName: 'deviceId',
      label: 'Device ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Unique hardware/device identifier reported by the platform.',
      canEdit: false,
      canCreate: false,
      canFilter: true,
      canOrder:true,
      width: '16rem',
    },
    {
      attributeName: 'deviceType',
      label: 'Device Type',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'VR device model (e.g. Meta Quest 2, HTC Vive Pro 2).',
      canEdit: false,
      canCreate: false,
      canFilter: true,
      canOrder:true,
      width: '14rem',
    },
    {
      attributeName: 'user',
      label: 'User',
      type: FormInputTypes.RELATIONSHIP,
      helpText: 'User currently assigned to this device (can be empty).',
      canEdit: false,
      canCreate: true,
      canFilter: true,
      canOrder: true,
      configFile: viewRelatedUsers,
    },
    {
      attributeName: 'tags',
      label: 'Tag',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Optional tags to help identify or group devices.',
      canEdit: false,
      canCreate: true,
      canFilter: true,
      canOrder:true,
      width: '12rem',
    },
  ],
};
